export const teamImagesSelector = state => state.entities.teamImages;
